module.exports = __webpack_public_path__ + "c0d6c6c069d9181bd94babb2fc82c8d9.svg";